// src/components/ItemForm.tsx
import React, { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import '../styles/ItemForm.css';
import { updateCategoria, createItem } from '../services/categorias';

interface ItemFormProps {
  level: 'departamento' | 'categoria' | 'subcategoria';
  parent?: any;
  onClose: () => void;
  onSuccess: (message: string) => void;
  itemData?: any;
}

const ItemForm: React.FC<ItemFormProps> = ({ level, parent, onClose, onSuccess, itemData }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
  });
  const [loading, setLoading] = useState(false);

  // Effect to load data when itemData changes
  useEffect(() => {
    if (itemData) {
      setFormData({
        nombre: itemData.nombre || '',
        descripcion: itemData.descripcion || '',
      });
    }
  }, [itemData]);

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (itemData?.id) {
        await updateCategoria(level, formData, parent, itemData.id);
        onSuccess(`¡${level} actualizado correctamente!`);
      } else {
        await createItem(level, formData, parent);
        onSuccess(`¡${level} creado correctamente!`);
      }
      setFormData({ nombre: '', descripcion: '' });
    } catch (error) {
      console.error(`Error al ${itemData?.id ? 'actualizar' : 'crear'} ${level}:`, error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <form className="item-form" onSubmit={handleSubmit}>
      <h3 className="form-title">{itemData?.id ? `Editar ${level}` : `Crear ${level}`}</h3>
      <label>
        Nombre:
        <input
          type="text"
          name="nombre"
          value={formData.nombre}
          onChange={handleChange}
          placeholder={`Nombre del ${level}`}
          required
        />
      </label>
      <label>
        Descripción:
        <textarea
          name="descripcion"
          value={formData.descripcion}
          onChange={handleChange}
          placeholder={`Descripción del ${level}`}
          required
        />
      </label>
      <button type="submit" className="button primary" disabled={loading}>
        {loading ? 'Guardando...' : itemData?.id ? 'Actualizar' : 'Crear'}
      </button>
      <button
        type="button"
        className="button secondary"
        onClick={onClose}
        disabled={loading}
      >
        Cancelar
      </button>
    </form>
  );
};

export default ItemForm;
